import React, { useEffect, useState } from "react";
import axios from "axios";

const FeatureTwo = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://allyoutube01-2d46d9aff565.herokuapp.com/api/feature-two-section",
        );
        setData(res.data.data);
      } catch (err) {
        setError("Failed to load feature section.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return (
      <div 
        className="container text-center py-5" 
        style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}
      >
        <div className="spinner-border text-danger" role="status"></div>
      </div>
    );
    
  if (error || !data || !data.isActive) return null;

  return (
    <>
      <section 
        className="feature-section-professional position-relative"
        style={{ 
          backgroundColor: '#0b0b14', // Deep dark background
          paddingTop: '120px',
          paddingBottom: '120px',
          overflow: 'hidden'
        }}
      >
        {/* Background Decorative Element - Large Gradient Blob */}
        <div 
          style={{
            position: 'absolute',
            top: '-10%',
            right: '-10%',
            width: '600px',
            height: '600px',
            background: 'radial-gradient(circle, rgba(225, 36, 36, 0.15) 0%, rgba(0, 0, 0, 0) 70%)',
            filter: 'blur(60px)',
            zIndex: '0',
            borderRadius: '50%'
          }}
        ></div>

        <div className="container position-relative" style={{ zIndex: '2' }}>
          <div className="row g-5 align-items-center">
            
            {/* LEFT: Image Section with Gradient Border */}
            <div className="col-lg-6 col-md-12">
              <div className="position-relative">
                {/* Gradient Border Wrapper */}
                <div 
                  className="gradient-border-wrapper position-relative"
                  style={{
                    background: 'linear-gradient(135deg, #e12424, #4a1c40, #0b0b14)',
                    padding: '3px', // Border thickness
                    borderRadius: '20px',
                    boxShadow: '0 30px 60px rgba(0,0,0,0.4)',
                    transform: 'perspective(1000px) rotateY(-5deg)', // Subtle 3D effect
                    transition: 'transform 0.5s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) scale(1.02)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(-5deg) scale(1)';
                  }}
                >
                  {/* Inner Dark Container */}
                  <div 
                    style={{
                      background: '#0b0b14',
                      borderRadius: '18px',
                      overflow: 'hidden'
                    }}
                  >
                    <img 
                      src={data.mainImage} 
                      alt="Professional Feature" 
                      className="img-fluid w-100" 
                      style={{ display: 'block', opacity: '0.9' }}
                    />
                  </div>
                </div>

                {/* Floating Glass Badge */}
                {data.shapeImage && (
                  <div 
                    className="position-absolute d-flex align-items-center p-3"
                    style={{
                      bottom: '-20px',
                      right: '-20px',
                      background: 'rgba(255, 255, 255, 0.05)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      borderRadius: '16px',
                      boxShadow: '0 15px 35px rgba(0,0,0,0.3)',
                      zIndex: '5',
                      maxWidth: '150px'
                    }}
                  >
                    <img 
                      src={data.shapeImage} 
                      alt="Badge" 
                      style={{ width: '40px', height: '40px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    <div>
                      <span className="d-block text-white fw-bold" style={{ fontSize: '0.8rem', lineHeight: '1' }}>
                        Top Rated
                      </span>
                      <span className="d-block" style={{ color: '#e12424', fontSize: '0.7rem', textTransform: 'uppercase' }}>
                        AI Tool
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT: Content Section */}
            <div className="col-lg-6 col-md-12">
              <div className="ps-lg-5">
                {/* Professional Badge */}
                <div 
                  className="d-inline-block px-3 py-1 rounded-pill mb-4 border"
                  style={{ 
                    borderColor: 'rgba(225, 36, 36, 0.3)', 
                    background: 'rgba(225, 36, 36, 0.1)',
                    color: '#ff8fa3',
                    fontSize: '0.8rem',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                    fontWeight: '600'
                  }}
                >
                  {data.subtitle}
                </div>

                {/* Main Heading */}
                <h2 
                  className="text-white mb-4 fw-bolder"
                  style={{ 
                    fontSize: '3rem', 
                    lineHeight: '1.1',
                    background: 'linear-gradient(to right, #ffffff, #a0a0a0)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}
                >
                  {data.title}
                </h2>

                {/* Description */}
                <p 
                  className="text-secondary mb-5 pe-3" 
                  style={{ 
                    fontSize: '1.125rem', 
                    lineHeight: '1.8',
                    color: '#b0b0d0'
                  }}
                >
                  {data.description}
                </p>

                {/* Features Grid */}
                <div className="row g-4 mb-5">
                  {data.listItems.map((item) => (
                    <div className="col-md-6" key={item.id}>
                      <div 
                        className="feature-item p-3 rounded-3 d-flex align-items-start"
                        style={{
                          background: 'rgba(255, 255, 255, 0.03)',
                          border: '1px solid rgba(255, 255, 255, 0.05)',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(225, 36, 36, 0.1)';
                          e.currentTarget.style.borderColor = 'rgba(225, 36, 36, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.05)';
                        }}
                      >
                        <div 
                          className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '36px',
                            height: '36px',
                            background: 'rgba(225, 36, 36, 0.15)',
                            color: '#e12424',
                            marginTop: '2px'
                          }}
                        >
                          <i className="icofont-check"></i>
                        </div>
                        <span className="text-white" style={{ fontSize: '0.95rem', fontWeight: '500' }}>
                          {item.text}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <div className="d-flex gap-3 align-items-center">
                  <a 
                    href={data.button.link} 
                    className="btn text-white fw-bold px-5 py-3 rounded-3 text-decoration-none d-inline-flex align-items-center justify-content-center"
                    style={{
                      background: '#e12424',
                      boxShadow: '0 10px 25px rgba(225, 36, 36, 0.4)',
                      transition: 'all 0.3s ease',
                      fontSize: '1rem'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#ff3333';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#e12424';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    {data.button.text}
                    <i className="icofont-arrow-right ms-2"></i>
                  </a>
                 
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default FeatureTwo;